module.exports = __webpack_public_path__ + "static/media/image-central-crop3.e4df8dfa.png";